module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), (_vm.base.title) ? _c('div', {
    staticClass: "component-header"
  }, [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-title"
  }, [_c('div', [_vm._v("专题配置")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e7b79774", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7b79774"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/special.vue
// module id = 2961
// module chunks = 0